// extracted by mini-css-extract-plugin
export default {"container":"styles_container__R3Qth","title":"styles_title__LSHfN"};